import React from 'react';
const tomos = [{
  color: '🟢',
  title: 'BAND 1',
  subtitle: 'Technik & Fundamente',
  desc: 'Ballhandling & Fußarbeit',
  features: 'Grundlagen · Dribbling-Basics · Schrittfehler vermeiden · Körperkontrolle'
}, {
  color: '🟡',
  title: 'BAND 2',
  subtitle: 'Dribbling & Passsysteme',
  desc: 'Dynamik & Spielaufbau',
  features: 'Passarten · Court Vision · Fast Break · Ballbewegung'
}, {
  color: '🟠',
  title: 'BAND 3',
  subtitle: 'Shooting Mastery',
  desc: 'Wurfmechanik & Korbleger',
  features: 'B.E.E.F. Prinzip · Layups · Freiwürfe · Wurf aus dem Dribbling'
}, {
  color: '🔴',
  title: 'BAND 4',
  subtitle: 'Defense & Rebound',
  desc: 'Positionierung & Verteidigung',
  features: 'Closeouts · Box Out · Help Defense · Rebounding-Techniken'
}, {
  color: '🟣',
  title: 'BAND 5',
  subtitle: 'Taktik & Spielintelligenz',
  desc: 'Motion Offense & Pick & Roll',
  features: 'Spacing · Screens · Cuts · Team-Offense'
}, {
  color: '⭐',
  title: 'BAND 6',
  subtitle: 'Der 365-Tage Saisonplaner',
  desc: 'Jahreskalender & Templates',
  features: 'Trainingspläne · Saisonblöcke · Vorlagen · Evaluation'
}];
const features = ['Jahresplanungskalender', 'Komplette, fertige Einheiten', 'Vordefinierte Lernziele', 'Bewertungs- und Einschätzungsbögen', 'Schüler-Fortschrittsverfolgung', 'Anpassungen für kleine & große Gruppen', 'Variationen für verschiedene Alters- & Könnensstufen'];
export function WhatYouGet() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-268">
      <div className="max-w-5xl mx-auto" data-id="element-269">
        <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] text-center mb-12 tracking-tight" data-id="element-270">
          Inhalt: Die 6 kompletten Bände
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-271">
          {tomos.map(tomo => <div key={tomo.title} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-272">
              <div className="flex items-center gap-3 mb-4" data-id="element-273">
                <span className="text-2xl" data-id="element-274">{tomo.color}</span>
                <div data-id="element-275">
                  <h3 className="font-black text-[#0A0A0A] text-sm tracking-wider uppercase" data-id="element-276">
                    {tomo.title}
                  </h3>
                  <p className="text-[#FF6B00] font-bold text-lg leading-tight" data-id="element-277">
                    {tomo.subtitle}
                  </p>
                </div>
              </div>
              <p className="text-[#0A0A0A] font-bold text-sm mb-2" data-id="element-278">
                {tomo.desc}
              </p>
              <p className="text-[#5A5A66] text-sm font-medium leading-relaxed mt-auto" data-id="element-279">
                {tomo.features}
              </p>
            </div>)}
        </div>

        <div className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 sm:p-8" data-id="element-280">
          <h4 className="text-center font-black text-[#0A0A0A] mb-6 uppercase tracking-wider text-sm" data-id="element-281">
            Was jeder Band beinhaltet
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3 max-w-3xl mx-auto" data-id="element-282">
            {features.map(f => <span key={f} className="text-[#0A0A0A] text-sm font-bold flex items-center gap-2" data-id="element-283">
                <span className="text-[#00C853] text-lg flex-shrink-0" data-id="element-284">✅</span>
                <span data-id="element-285">{f}</span>
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}